import {Component, EventEmitter, Output} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {AppAuthService} from "@services/core/auth/app-auth.service";
import {IntlPhoneNumComponent} from "@clinician/shared/components/intl-phone-num/intl-phone-num.component";
import {IconComponent} from "@shared/components/icon/icon.component";
import {LocalizeTextPipe} from "@shared/pipes/localize-text/localize-text.pipe";
import {OtpAuthService} from "@app/areas/auth/services/otp-auth.service";

@Component({
  selector: 'app-auth-otp',
  standalone: true,
  imports: [FormsModule, IntlPhoneNumComponent, IconComponent, LocalizeTextPipe],
  templateUrl: './auth-otp.component.html',
  styleUrls: ['./auth-otp.component.scss'],
})
export class AuthOtpComponent {
  @Output() otpToken = new EventEmitter<{ token: string, phoneNumber: string }>();

  phoneNumber = '';
  verificationCode = '';

  stage: 'enterPhone' | 'enterCode' | 'done' = 'enterPhone';
  loading = false;
  errorMessage = '';

  private _otpCodeToken: string | null = null;

  constructor(
    private auth: OtpAuthService,
  ) {
  }

  sendOtp() {
    this.errorMessage = '';
    this.loading = true;
    this.auth.sendOtp(this.phone)
      .subscribe({
        next: (res) => {
          this._otpCodeToken = res.token;
          this.loading = false;
          this.stage = 'enterCode';
        },
        error: err => {
          this.loading = false;
          this.errorMessage = err?.message || 'Failed to send OTP';
        }
      });
  }

  verifyOtp() {
    this.errorMessage = '';
    this.loading = true;
    this.auth.verifyOtp(this._otpCodeToken, this.verificationCode.trim())
      .subscribe({
        next: response => {
          this.loading = false;
          this.otpToken.emit({token: response.token, phoneNumber: this.phone})
        },
        error: err => {
          this.loading = false;
          this.errorMessage = err?.message || 'Invalid code';
        }
      });
  }

  get phone(): string {
    return this.phoneNumber.trim()
  }
}
